import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";

// Fetching Data from the API]

// End

// Page Html
export default function Readaloud() {
  const [readaloudData, setReadaloudData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReadaloudData = async () => {
      try {
        const response = await fetch("/api/questions/readaloud", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setReadaloudData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch Readaloud data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching Readaloud data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchReadaloudData();
  }, []); // Empty dependency array to fetch data only once on mount

  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Read Aloud" id={readaloudData.data} />

    </div>
  );
}
